import './PurchasedNFT.css';

function CreatedNFT(props) {
  let ethToWeiConversion = 1000000000000000000;
  return (
    <div className="flex p-4 items-center justify-center cursor-pointer" onClick={props.handleItemClick}>
      <div>
        <div className="flex bg-custom-gray">
          <img className="h-96 w-96 object-cover" src={props.image} alt="PPV NFT" />
        </div>
        <div className="flex">
          <div className="flex-col whitespace-nowrap overflow-hidden text-ellipsis">
            <div className="flex">
              <div className="flex-col">
                <div className="text-lg mt-2 hover:underline hover:text-gray-400 text-gray-600 dark:text-gray-300">
                  {props.name}
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          props.price && props.editions
            ?
          <div className = "flex justify-around w-80 h-8 border-t dark:border-zinc-800">
            <div className="flex mt-8">
              <div className = "flex items-center text-black dark:text-white text-sm">
                Editions:
              </div>
              <div className = "flex items-center ml-2 mr-4 text-black dark:text-white text-sm font-bold">
                {props.editions}
              </div>
            </div>
            <div className="flex mt-8">
              <div className = "flex items-center text-black dark:text-white text-sm">
                Price:
              </div>
              <div className = "flex items-center ml-2 mr-4 text-black dark:text-white text-sm font-bold">
                {parseInt(props.price)/ethToWeiConversion + " ETH"}
              </div>
            </div>
          </div>
            :
          null
        }
      </div>
    </div>
  );
}

export default CreatedNFT;
